_ = require 'underscore'
Auth = require 'db/auth'
BoardsSidebarBoardsView = require 'views/boards-sidebar/boards-sidebar-boards-view'
BoardsSidebarMyBoardsSectionView = require 'views/boards-sidebar/boards-sidebar-my-boards-section-view'
BoardsSidebarOrgSectionView = require 'views/boards-sidebar/boards-sidebar-org-section-view'
BoardsSidebarRecentSectionView = require 'views/boards-sidebar/boards-sidebar-recent-section-view'
BoardsSidebarStarredSectionView = require 'views/boards-sidebar/boards-sidebar-starred-section-view'
ModelLoader = require 'db/model-loader'
template = require 'views/templates/boards_sidebar_boards'

module.exports = class BoardsSidebarAllBoardsView extends BoardsSidebarBoardsView
  initialize: ->
    @listenTo @model.organizationList, 'add remove reset',
      @frameDebounce @renderBoardsSections

  renderOnce: ->
    @$el.html template()

    @renderBoardsSections()

    @

  renderBoardsSections: ->
    @renderStarredBoardsSection()
    @renderRecentBoardsSection()
    @renderAllBoardsSection()

    @

  renderAllBoardsSection: ->
    $container = @$('.js-all-boards')
    boards = (board for board in @model.boardList.models when board.isOpen())

    if boards.length == 0
      onBoardAdd = =>
        @stopListening Auth.me().boardList, 'add reset', onBoardAdd
        @renderAllBoardsSection()
      @listenTo Auth.me().boardList, 'add reset', onBoardAdd

    else
      @appendSubview(@subview(BoardsSidebarMyBoardsSectionView, Auth.me(), {}, 'my-boards'), $container)

      for org in @model.getSortedOrgs()
        @appendSubview(@subview(BoardsSidebarOrgSectionView, Auth.me(), { org }, "group-#{org.id}"), $container)

    @

  renderStarredBoardsSection: ->
    @appendSubview(@subview(BoardsSidebarStarredSectionView, Auth.me(), {}, 'starred-boards'), @$('.js-starred-boards'))

    @

  renderRecentBoardsSection: ->
    ModelLoader.waitFor 'boardsData', =>
      @appendSubview(@subview(BoardsSidebarRecentSectionView, Auth.me(), {}, 'recent-boards'), @$('.js-recent-boards'))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-all-boards-view.coffee